import React, { useState, useEffect } from 'react';

const PaginationWrap = ({
  itemPerPage,
  currentPage,
  totalPages,
  handleClickPageNumber,
  totalItems,
  items
}) => {
  const [currentPageArr, setCurrentPageArr] = useState([]);
  useEffect(() => {
    const initialPageArr = [];
    for (let i = 1; i <= totalPages && i <= 5; i++) {
      initialPageArr.push(i);
    }
    setCurrentPageArr(initialPageArr);
  }, [totalPages]);

  const onNextClick = (evt) => {
    let visiblePagesArr = [];
    if (currentPage % 5 === 0) {
      for (let i = currentPage + 1; i < currentPage + 6 && i <= totalPages; i++) {
        visiblePagesArr.push(i);
      }

      setCurrentPageArr(visiblePagesArr);
      handleClickPageNumber(currentPage + 1);
    } else {
      handleClickPageNumber(currentPage + 1);
    }

  }
  const onPreviousBtnClick = () => {
    let visiblePagesArr = [];
    if ((currentPage - 1) % 5 === 0) {
      for (let i = currentPage - 1; i >= currentPage - 5 && i >= 1; i--) {
        visiblePagesArr.unshift(i);
      }
      setCurrentPageArr(visiblePagesArr);
      handleClickPageNumber(currentPage - 1);
    } else {
      handleClickPageNumber(currentPage - 1);
    }
  }

  const calculateStartIndex = () => {
    return (currentPage - 1) * itemPerPage + 1;
  };

  const calculateEndIndex = () => {
    const end = currentPage * items;
    return totalPages == currentPage ? totalItems : end;
  };

  return (
    <div className='pagination-wrap'>
      <p className='page-num'>
        {"Page"} {currentPage} {" of "} {totalPages} and Showing{" "}
        {calculateStartIndex()} - {calculateEndIndex()} / {totalItems} Total items
      </p>
      <div className='page-num-box'>
        <ul>
          {currentPage > 1 ? (
            <li key="prev" onClick={onPreviousBtnClick}>
              &laquo;
            </li>
          ) : null}
          {currentPageArr &&
            currentPageArr.map((page) => (
              <li
                onClick={() => handleClickPageNumber(page)}
                key={page}
                className={`${currentPage === page ? 'active' : ''}`}
              >
                {page}
              </li>
            ))}
          {currentPage < totalPages ? (
            <li key="next" onClick={onNextClick}>
              &raquo;
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
};
export default PaginationWrap;